// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListSettingsModal-space1-yMlvX {
	margin-bottom: 6px !important;
}

.ListSettingsModal-space2-YmEV3 {
	margin-bottom: 12px !important;
}

.ListSettingsModal-space3-JeLs3 {
	margin-bottom: 18px !important;
}

.ListSettingsModal-space4-B8rm5 {
	margin-bottom: 24px !important;
}

.ListSettingsModal-space5-cHfQG {
	margin-bottom: 30px !important;
}

.ListSettingsModal-space6-xGCDi {
	margin-bottom: 36px !important;
}

.ListSettingsModal-space7-Uoifn {
	margin-bottom: 42px !important;
}

.ListSettingsModal-space8-PU1c1 {
	margin-bottom: 48px !important;
}

.ListSettingsModal-spaceTop1-tMHLQ {
	margin-top: 6px !important;
}

.ListSettingsModal-spaceTop2-bLvIr {
	margin-top: 12px !important;
}

.ListSettingsModal-spaceTop3-cscq1 {
	margin-top: 18px !important;
}

.ListSettingsModal-spaceTop4-vQiR0 {
	margin-top: 24px !important;
}

.ListSettingsModal-spaceTop5-VWMn4 {
	margin-top: 30px !important;
}

.ListSettingsModal-spaceTop6-Nt7Ks {
	margin-top: 36px !important;
}

.ListSettingsModal-spaceTop7-J15zV {
	margin-top: 42px !important;
}

.ListSettingsModal-spaceTop8-LiH0b {
	margin-top: 48px !important;
}

.ListSettingsModal-noMargin-V_819 {
	margin: 0px !important;
}

.ListSettingsModal-padding1-XYf4A {
	padding-bottom: 6px !important;
}

.ListSettingsModal-padding2-Xgl0A {
	padding-bottom: 12px !important;
}

.ListSettingsModal-padding3-MWCLY {
	padding-bottom: 18px !important;
}

.ListSettingsModal-padding4-uJk1i {
	padding-bottom: 24px !important;
}

.ListSettingsModal-padding5-fOk0f {
	padding-bottom: 30px !important;
}

.ListSettingsModal-padding6-BmCug {
	padding-bottom: 36px !important;
}

.ListSettingsModal-padding7-p0Cys {
	padding-bottom: 42px !important;
}

.ListSettingsModal-paddingTop1-iOD5p {
	padding-top: 6px !important;
}

.ListSettingsModal-paddingTop2-HcxtZ {
	padding-top: 12px !important;
}

.ListSettingsModal-paddingTop3-mqU0q {
	padding-top: 18px !important;
}

.ListSettingsModal-paddingTop4-Lcg2b {
	padding-top: 24px !important;
}

.ListSettingsModal-paddingTop5-vlmF5 {
	padding-top: 30px !important;
}

.ListSettingsModal-paddingTop6-wxUEO {
	padding-top: 36px !important;
}

.ListSettingsModal-paddingTop7-dMC6T {
	padding-top: 42px !important;
}

.ListSettingsModal-noPadding-pjI2c {
	padding: 0px !important;
}

.ListSettingsModal-spaceMarginBottom0-Y7WUs {
	margin-bottom: 0;
}

.ListSettingsModal-textBold-k0KwC {
	font-weight: 500 !important;
}

.ListSettingsModal-textBolder-RkAmq {
	font-weight: 700 !important;
}

.ListSettingsModal-textNormal-sqS4y {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ListSettingsModal-textDarkBlue-EqXSK {
	color: rgb(20, 39, 94) !important;
}

.ListSettingsModal-textLightBlue-_KcDJ {
	color: rgb(57, 87, 106) !important;
}

.ListSettingsModal-textLightSandleGreen-OraWH {
	color: rgb(76, 86, 41) !important;
}

.ListSettingsModal-textLightBrown-pQ3o_ {
	color: rgb(115, 79, 33) !important;
}

.ListSettingsModal-textMediumMaroon-LekWX {
	color: rgb(87, 37, 51) !important;
}

.ListSettingsModal-textBrown-W5B90 {
	color: rgb(160, 47, 24) !important;
}

.ListSettingsModal-textMaroon-K8FvM {
	color: rgb(155, 49, 67) !important;
}

.ListSettingsModal-textDarkBrown-j9P1h {
	color: rgb(83, 18, 16) !important;
}

.ListSettingsModal-textMediumBrown-KgAV6 {
	color: rgb(142, 28, 10) !important;
}

.ListSettingsModal-textSkyBlue-ejpnU {
	color: rgb(37, 117, 141) !important;
}

.ListSettingsModal-textGray-MuvOx {
	color: rgb(77, 65, 51) !important;
}

.ListSettingsModal-errorMessage-_jmvS {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ListSettingsModal-userText-VFeJh {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ListSettingsModal-panelHeader-J_YK9 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ListSettingsModal-exportSection-gwiPy {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ListSettingsModal-exportSectionGridSub-Ylk9R {
	grid-template-columns: 50% 49% !important;
}

.ListSettingsModal-exportText-nBuNw {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ListSettingsModal-exportLinkImg-M96Wo {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ListSettingsModal-exportImg-kRISw {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ListSettingsModal-linkBtn-d5yvd {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ListSettingsModal-table-vEb80 {
	display: table;
}

.ListSettingsModal-tableRow-klvUi {
	display: table-row;
}

.ListSettingsModal-tableCell-uDu6n {
	display: table-cell;
	float: none;
}

.ListSettingsModal-formGroup-ttN2o {
	margin-bottom: 6px;
}

.ListSettingsModal-marginTop0-uhuAG {
	margin-top: 0;
}

.ListSettingsModal-marginBottom20-PmkBM {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ListSettingsModal-bannerImageBg-_rJdW {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ListSettingsModal-bannerDelete-bALfk {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ListSettingsModal-exportLink-veIK4 {
	padding-top: 10px;
	padding-right: 10px;
}

.ListSettingsModal-seachContent-uopxU {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ListSettingsModal-marginBottom9-JnWic {
	margin-bottom: 9px;
}

.ListSettingsModal-spaceTop52-jhK0C {
	margin-top: 52px;
}

.ListSettingsModal-profileViewInner-VSZRK {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ListSettingsModal-profileViewMain-RFxyx {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ListSettingsModal-profileViewlabel-C3wtg {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ListSettingsModal-profileViewMainContent-pRzvA {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ListSettingsModal-reviewsFormStar-uDJF3 {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ListSettingsModal-reviewsFormStar-uDJF3 svg {
	cursor: pointer;
}

.ListSettingsModal-addLanguageText-IInm2 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ListSettingsModal-exportSection-gwiPy {
		grid-template-columns: 100%;
	}

	.ListSettingsModal-spaceTop52-jhK0C {
		margin-top: 18px;
	}

	.ListSettingsModal-exportText-nBuNw {
		float: none;
		margin-top: 12px;
	}

	.ListSettingsModal-exportSectionGridSub-Ylk9R {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ListSettingsModal-profileViewlabel-C3wtg {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ListSettingsModal-profileViewMainContent-pRzvA {
		width: 100%;
		text-align: center;
	}

	.ListSettingsModal-panelHeader-J_YK9 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ListSettingsModal-space1-yMlvX`,
	"space2": `ListSettingsModal-space2-YmEV3`,
	"space3": `ListSettingsModal-space3-JeLs3`,
	"space4": `ListSettingsModal-space4-B8rm5`,
	"space5": `ListSettingsModal-space5-cHfQG`,
	"space6": `ListSettingsModal-space6-xGCDi`,
	"space7": `ListSettingsModal-space7-Uoifn`,
	"space8": `ListSettingsModal-space8-PU1c1`,
	"spaceTop1": `ListSettingsModal-spaceTop1-tMHLQ`,
	"spaceTop2": `ListSettingsModal-spaceTop2-bLvIr`,
	"spaceTop3": `ListSettingsModal-spaceTop3-cscq1`,
	"spaceTop4": `ListSettingsModal-spaceTop4-vQiR0`,
	"spaceTop5": `ListSettingsModal-spaceTop5-VWMn4`,
	"spaceTop6": `ListSettingsModal-spaceTop6-Nt7Ks`,
	"spaceTop7": `ListSettingsModal-spaceTop7-J15zV`,
	"spaceTop8": `ListSettingsModal-spaceTop8-LiH0b`,
	"noMargin": `ListSettingsModal-noMargin-V_819`,
	"padding1": `ListSettingsModal-padding1-XYf4A`,
	"padding2": `ListSettingsModal-padding2-Xgl0A`,
	"padding3": `ListSettingsModal-padding3-MWCLY`,
	"padding4": `ListSettingsModal-padding4-uJk1i`,
	"padding5": `ListSettingsModal-padding5-fOk0f`,
	"padding6": `ListSettingsModal-padding6-BmCug`,
	"padding7": `ListSettingsModal-padding7-p0Cys`,
	"paddingTop1": `ListSettingsModal-paddingTop1-iOD5p`,
	"paddingTop2": `ListSettingsModal-paddingTop2-HcxtZ`,
	"paddingTop3": `ListSettingsModal-paddingTop3-mqU0q`,
	"paddingTop4": `ListSettingsModal-paddingTop4-Lcg2b`,
	"paddingTop5": `ListSettingsModal-paddingTop5-vlmF5`,
	"paddingTop6": `ListSettingsModal-paddingTop6-wxUEO`,
	"paddingTop7": `ListSettingsModal-paddingTop7-dMC6T`,
	"noPadding": `ListSettingsModal-noPadding-pjI2c`,
	"spaceMarginBottom0": `ListSettingsModal-spaceMarginBottom0-Y7WUs`,
	"textBold": `ListSettingsModal-textBold-k0KwC`,
	"textBolder": `ListSettingsModal-textBolder-RkAmq`,
	"textNormal": `ListSettingsModal-textNormal-sqS4y`,
	"textDarkBlue": `ListSettingsModal-textDarkBlue-EqXSK`,
	"textLightBlue": `ListSettingsModal-textLightBlue-_KcDJ`,
	"textLightSandleGreen": `ListSettingsModal-textLightSandleGreen-OraWH`,
	"textLightBrown": `ListSettingsModal-textLightBrown-pQ3o_`,
	"textMediumMaroon": `ListSettingsModal-textMediumMaroon-LekWX`,
	"textBrown": `ListSettingsModal-textBrown-W5B90`,
	"textMaroon": `ListSettingsModal-textMaroon-K8FvM`,
	"textDarkBrown": `ListSettingsModal-textDarkBrown-j9P1h`,
	"textMediumBrown": `ListSettingsModal-textMediumBrown-KgAV6`,
	"textSkyBlue": `ListSettingsModal-textSkyBlue-ejpnU`,
	"textGray": `ListSettingsModal-textGray-MuvOx`,
	"errorMessage": `ListSettingsModal-errorMessage-_jmvS`,
	"userText": `ListSettingsModal-userText-VFeJh`,
	"panelHeader": `ListSettingsModal-panelHeader-J_YK9`,
	"exportSection": `ListSettingsModal-exportSection-gwiPy`,
	"exportSectionGridSub": `ListSettingsModal-exportSectionGridSub-Ylk9R`,
	"exportText": `ListSettingsModal-exportText-nBuNw`,
	"exportLinkImg": `ListSettingsModal-exportLinkImg-M96Wo`,
	"exportImg": `ListSettingsModal-exportImg-kRISw`,
	"linkBtn": `ListSettingsModal-linkBtn-d5yvd`,
	"table": `ListSettingsModal-table-vEb80`,
	"tableRow": `ListSettingsModal-tableRow-klvUi`,
	"tableCell": `ListSettingsModal-tableCell-uDu6n`,
	"formGroup": `ListSettingsModal-formGroup-ttN2o`,
	"marginTop0": `ListSettingsModal-marginTop0-uhuAG`,
	"marginBottom20": `ListSettingsModal-marginBottom20-PmkBM`,
	"bannerImageBg": `ListSettingsModal-bannerImageBg-_rJdW`,
	"bannerDelete": `ListSettingsModal-bannerDelete-bALfk`,
	"exportLink": `ListSettingsModal-exportLink-veIK4`,
	"seachContent": `ListSettingsModal-seachContent-uopxU`,
	"marginBottom9": `ListSettingsModal-marginBottom9-JnWic`,
	"spaceTop52": `ListSettingsModal-spaceTop52-jhK0C`,
	"profileViewInner": `ListSettingsModal-profileViewInner-VSZRK`,
	"profileViewMain": `ListSettingsModal-profileViewMain-RFxyx`,
	"profileViewlabel": `ListSettingsModal-profileViewlabel-C3wtg`,
	"profileViewMainContent": `ListSettingsModal-profileViewMainContent-pRzvA`,
	"reviewsFormStar": `ListSettingsModal-reviewsFormStar-uDJF3`,
	"addLanguageText": `ListSettingsModal-addLanguageText-IInm2`
};
module.exports = ___CSS_LOADER_EXPORT___;
